import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AccountView } from '@api-proxies';
import { AccountService } from '@http/clients/account.service';
import { TabNames } from '@models/enums/TabNames';
import { EditorComponentBase } from 'ngx-lib';
import { InternalNavigatorComponent } from '../../internal-navigator/internal-navigator.component';
import { TypeAheadAccountsComponent } from '../../type-ahead-accounts/type-ahead-accounts.component';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-account-editor',
    templateUrl: './account-editor.component.html',
    styleUrls: ['./account-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [InternalNavigatorComponent, TypeAheadAccountsComponent, ValidationErrorMessageComponent]
})
export class AccountEditorComponent extends EditorComponentBase<number | undefined> implements OnInit {
    selectedAccount?: AccountView;

    displaySelectedAccount: boolean;

    allowToNavigate?: boolean;

    routeToSingle?: string;

    constructor(private readonly accountService: AccountService) {
        super();
        this.displaySelectedAccount = true;
    }

    async ngOnInit(): Promise<void> {
        this.allowToNavigate = this.additionalInfo?.allowToNavigate;
        if (this.bindingProperty) {
            this.selectedAccount = await this.accountService.getById(this.bindingProperty);
            if (this.allowToNavigate) this.setRouteToNavigate(this.selectedAccount);
        }
    }

    onSelectedAccount(account: AccountView) {
        this.selectedAccount = account;
        this.bindingProperty = this.selectedAccount?.id;
        if (this.allowToNavigate && this.selectedAccount) this.setRouteToNavigate(this.selectedAccount);
        this.validate();
        this.valueChange.emit();
    }

    setRouteToNavigate(account: AccountView) {
        this.routeToSingle = `accounts-single/${account.id}/${TabNames[TabNames.Overview]}`;
    }
}
